export default __webpack_public_path__ + "static/comingsoon-a65de6c761e4f0100499f2ab82637af6.gif";